// extracted by mini-css-extract-plugin
export default {"brandPromo":"aG-z","carousel":"bG-z"};